import { LoginForm } from "@/components/LoginForm";
import logoViable from "@/assets/logo-viabiliza.png";
import Footer from "@/components/Footer";
const Login = () => {
  return <div className="min-h-screen w-full bg-white flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
        {/* Logo Section - Left Side */}
        <div className="flex flex-col items-center justify-center space-y-6">
          <div className="relative">
            <img alt="Viabiliza Logo" className="w-full max-w-lg h-auto object-contain transition-all duration-500 hover:scale-105" src="/lovable-uploads/1925c3e2-2098-4318-8e09-c8c6d4b8c732.png" />
          </div>
        </div>

          {/* Login Form Section - Right Side */}
          <div className="flex items-center justify-center lg:justify-start">
            <LoginForm />
          </div>
        </div>
      </div>
      
      <Footer />
    </div>;
};
export default Login;
